import { createAction, createSlice } from '@reduxjs/toolkit';
import { deprecationWarning } from '@wsc/utils/consoleHelpers';

/** Deprecated events */
const SET_PRE_SCENE_VISIBILITY = 'SET_PRE_SCENE_VISIBILITY';
const SET_SCENE_VISIBILITY = 'SET_SCENE_VISIBILITY';

const initialState = {
	preScreenVisible: true,
	renderScene: false,
	renderUI: false,
	activeScene: '',
	previousScene: '',
	sceneBgLoaded: false,
	allHotspotsLoaded: false,
};

const slice = createSlice({
	name: 'sceneLoad',
	initialState,
	reducers: {
		setPreScreenVisibility(state, action) {
			state.preScreenVisible = action.payload;
		},
		setSceneVisibility(state, action) {
			state.renderScene = action.payload;
		},
		setActiveScene(state, action) {
			state.previousScene = state.activeScene;
			state.activeScene = action.payload;
		},
		setRenderUI(state, action) {
			state.renderUI = action.payload;
		},
		setSceneBgLoaded(state, action) {
			state.sceneBgLoaded = action.payload;
		},
		setAllHotspotsLoaded(state, action) {
			state.allHotspotsLoaded = action.payload;
		},
	},
	extraReducers: (builder) => {
		/** Backwards compatible events for functionality in Pre Screen Component variants */
		builder.addCase(
			createAction(SET_PRE_SCENE_VISIBILITY),
			(state, action) => {
				deprecationWarning(
					`'${SET_PRE_SCENE_VISIBILITY}' event is deprecated. Please use 'sceneLoad/setPreScreenVisibility' instead. Payload structure does not change.`,
				);
				state.preScreenVisible = action.payload;
			},
		);
		builder.addCase(createAction(SET_SCENE_VISIBILITY), (state, action) => {
			deprecationWarning(
				`'${SET_SCENE_VISIBILITY}' event is deprecated. Please use 'sceneLoad/setSceneVisibility' instead. Payload structure does not change.`,
			);
			state.renderScene = action.payload;
		});
	},
});

export const selectRenderScene = (state) => state.sceneLoad.renderScene;
export const selectRenderUI = (state) => state.sceneLoad.renderUI;
export const selectActiveScene = (state) => state.sceneLoad.activeScene;

export const selectSceneBgLoaded = (state) => state.sceneLoad.sceneBgLoaded;
export const selectAllHotspotsLoaded = (state) =>
	state.sceneLoad.allHotspotsLoaded;

export const {
	setPreScreenVisibility,
	setSceneVisibility,
	setActiveScene,
	setRenderUI,
	setSceneBgLoaded,
	setAllHotspotsLoaded,
} = slice.actions;

export default slice.reducer;
